import React from "react"
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  FacebookShareCount,
} from "react-share"

import "./_footer.scss"

const shareUrl = "https://katikamusic.netlify.app/"

const footer = () => {
  return (
    <div className="footer">
      <div className="footer__column">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSc9LTFUFM2fbiPMP37X0PnbASGWAU36_rf88pi9GKFAv7vD0g/viewform"
          target="_blank"
        >
          Submit Your Music
        </a>
      </div>

      <div className="footer__column">
        © <a href="https://www.katika.us">Katika</a>{" "}
        {new Date().getFullYear()}
      </div>

      <div className="footer__column">
        <div className="footer__row">
          <div className="footer__icons footer__icons--facebook">
            <FacebookShareButton
              url={shareUrl}
              quote="Explore black music around the world with Katika!"
              hashtag="katikaMusic"
            >
              <FacebookIcon size={25} round={true} />
            </FacebookShareButton>
            <div>
              <FacebookShareCount url={shareUrl}>
                {count => count}
              </FacebookShareCount>
            </div>
          </div>

          <div className="footer__icons footer__icons--email">
            <EmailShareButton
              url={shareUrl}
              subject="Explore black music around the work with katika!"
            >
              <EmailIcon size={25} round={true} />
            </EmailShareButton>
          </div>

          <div className="footer__icons footer__icons--linkedin">
            <LinkedinShareButton
              url={shareUrl}
              title="Katika Music"
              summary="An interactive music map to explore black music around the world"
              source="Katika Projects"
            >
              <LinkedinIcon size={25} round={true} />
            </LinkedinShareButton>
          </div>

          <div className="footer__icons footer__icons--twitter">
            <TwitterShareButton
              url={shareUrl}
              title="Katika Music"
              hashtags={["shopkatika", "blackmusic", "katikamusic"]}
            >
              <TwitterIcon size={25} round={true} />
            </TwitterShareButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default footer
